import React, { useState } from 'react';
import { Lock, Unlock } from 'lucide-react';
import AlertDialog from '../AlertDialog';

interface SettingsManagementProps {
  photoAlbumUnlockDate: Date;
  onUnlock: () => Promise<void>;
  onLock: () => Promise<void>;
}

const SettingsManagement: React.FC<SettingsManagementProps> = ({
  photoAlbumUnlockDate,
  onUnlock,
  onLock
}) => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const handleUnlock = async () => {
    try {
      await onUnlock();
      setAlertMessage('Álbum de fotos desbloqueado com sucesso!');
      setShowAlert(true);
    } catch (error) {
      console.error('Error unlocking photo album:', error);
      setAlertMessage('Erro ao desbloquear álbum. Por favor, tente novamente.');
      setShowAlert(true);
    }
  };

  const handleLock = async () => {
    try {
      await onLock();
      setAlertMessage('Álbum de fotos bloqueado com sucesso!');
      setShowAlert(true);
    } catch (error) {
      console.error('Error locking photo album:', error);
      setAlertMessage('Erro ao bloquear álbum. Por favor, tente novamente.');
      setShowAlert(true);
    }
  };

  return (
    <>
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="p-4 bg-wedding-beige-100 border-b">
          <h3 className="font-medium text-wedding-blue-800">Configurações</h3>
        </div>
        
        <div className="p-6">
          <div className="mb-8">
            <h4 className="text-lg font-medium text-wedding-blue-800 mb-4">Álbum de Fotos</h4>
            
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-sm text-gray-600 mb-4">
                Status atual: {new Date() >= photoAlbumUnlockDate ? (
                  <span className="text-green-600 font-medium">Desbloqueado</span>
                ) : (
                  <span className="text-red-600 font-medium">Bloqueado</span>
                )}
              </p>
              
              <p className="text-sm text-gray-600 mb-4">
                Data de desbloqueio: {photoAlbumUnlockDate.toLocaleDateString('pt-BR')}
              </p>
              
              <div className="flex gap-4">
                <button
                  onClick={handleUnlock}
                  className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
                >
                  <Unlock size={18} />
                  Desbloquear Agora
                </button>
                
                <button
                  onClick={handleLock}
                  className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
                >
                  <Lock size={18} />
                  Bloquear Álbum
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AlertDialog
        isOpen={showAlert}
        title="Notificação"
        message={alertMessage}
        onClose={() => setShowAlert(false)}
      />
    </>
  );
};

export default SettingsManagement;